/**
 * External Dependencies
 * Comment out scripts that are not used to save on page load
 */
import { Collapse, Dropdown, Modal, Popover, Tab } from 'bootstrap';
import { CountUp } from 'countup.js';
import 'select2';
// import AOS from 'aos';
import 'lazysizes/plugins/unveilhooks/ls.unveilhooks';
import 'lazysizes/plugins/bgset/ls.bgset';
import 'lazysizes/lazysizes';
import 'jquery.nicescroll';

/**
 * Internal Scripts
 * Comment out scripts that are not used to save on page load
 */
import './disclaimer.js';
// import './people.js';
import './slider.js';

// Hide show back to top links.
const backToTop = (el) => {
  if (window.pageYOffset > 300) {
    $(el).fadeIn();
  } else {
    $(el).fadeOut();
  }

  document.querySelectorAll(el).forEach(function(element, index) {
    element.addEventListener('click', function() {
      window.scroll({ top: 0, left: 0, behavior: 'smooth' });
    }, { once: true });
  });
};

const countStart = () => {
  const counters = document.querySelectorAll('.js-count-up');

  counters.forEach((item) => {
    const value = item.dataset.value;
    const decOptions = {
      decimalPlaces: 1,
    };

    if(value.indexOf('.') >= 0) {
      const counter = new CountUp(item, value, decOptions);
      counter.start();
    } else {
      const counter = new CountUp(item, value);
      counter.start();
    }
  });
};

$.fn.nice_scroll = function(options) {

  var $this = $(this); // selector

  var settings = $.extend({
      // These are the defaults.
      enable: true,
      cursorwidth: '5px',
      timeout: 0, // set delay before nice scroll appear
  }, options );

  setTimeout(function(){
    if(settings.enable === true) {
      $this.niceScroll({
        cursorwidth: settings.cursorwidth,
        emulatetouch: true,
        preventmultitouchscrolling: false,
        autohidemode: false,
        grabcursorenabled: false,
        scrollbarid: true,
        zindex: '99999',
      }).resize();
    }else {
      $this.niceScroll().remove();
    }
  }, settings.timeout);
};

$(() => {

  // AOS.init({
  //   once: true,
  //   disableMutationObserver: false,
  // });

  // AOS.refresh(true);

  // Get CSS variables
  const $window = $(window);
  let root = getComputedStyle(document.documentElement);
  let colorPrimary = root.getPropertyValue('--primary');
  let colorSecondary = root.getPropertyValue('--secondary');
  let xsBreakpoint = root.getPropertyValue('--breakpoint-xs').replace('px','');
  let smBreakpoint = root.getPropertyValue('--breakpoint-sm').replace('px','');
  let mdBreakpoint = root.getPropertyValue('--breakpoint-md').replace('px','');
  let lgBreakpoint = root.getPropertyValue('--breakpoint-lg').replace('px','');
  let xlBreakpoint = root.getPropertyValue('--breakpoint-xl').replace('px','');

  const navCollapsible = document.getElementById('navbar');
  const $body = $('body');

  // Scroll to open accordion
  // see example https://stackoverflow.com/questions/35992900/bootstrap-accordion-scroll-to-top-of-active-open-accordion-on-click#answer-35992958
  $('.accordion-collapse').on('shown.bs.collapse', function (e) {
    let $panel = $(this).closest('.accordion-item');
    if($('#wpadminbar').length) {
      $('html,body').animate({
        scrollTop: ($panel.offset().top - ($('header.header').outerHeight() + $('#wpadminbar').outerHeight())),
      }, 500);
    } else {
      $('html,body').animate({
        scrollTop: $panel.offset().top - $('header.header').outerHeight(),
      }, 500);
    }
  });

  // Enable select2
  $('select').not('.ur-frontend-field').select2({
    selectionCssClass: ':all:',
  });

  $('.disclaimer .modal-body').nice_scroll({enable:true, cursorwidth: '14px', timeout:800});

  // Count up on scroll to
  if ($('.stats').length) {
    const callback = (entries, observer) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          countStart('.stats')
          observer.unobserve(entry.target);
        }
      });
    }

    const observer = new IntersectionObserver(callback);
    const target = document.querySelector('.stats');
    observer.observe(target);
  }

  // Smooth scroll to
  $('.nav-link').on('click', function () {
    if (!$(this).hasClass("dropdown-toggle")) {
      const $link = $('.nav-link');
      const sectionTo = $(this).attr('href').replace(new RegExp('/', ''),"");
      const header = $('.header').height();
      const navbar = $('#navbar');
      const $this = $(this);

      $link.removeClass('active');
      $this.addClass('active');

      $(navbar).collapse('hide');

      $('html,body').animate({
        scrollTop: $(sectionTo).offset().top - header,
      }, 500);
    }
  });

  // Add scroll class on scroll/load
  $window.on("scroll load", function() {
    if($window.scrollTop() > 30) {
      $body.addClass("scroll-down");
    } else {
      $body.removeClass("scroll-down");
    }
  });

  // Popup modal
  $('a[href*="#bs-modal"]').each(function() {
    $(this).attr('data-bs-toggle', 'modal');
  });

  window.addEventListener('scroll', function() {
    backToTop('#back2top');
  });

  navCollapsible.addEventListener('shown.bs.collapse', event => {
    $body.addClass('nav-open');
  });

  navCollapsible.addEventListener('hidden.bs.collapse', event => {
    if($body.hasClass('nav-open')) {
      $body.removeClass('nav-open');
    }
  });
});

window.addEventListener('load', function () {
  backToTop('#back2top');
}, false);
